import Vue from 'vue';
import router from './router';
import App from './App.vue';
import 'cross-fetch/polyfill';
import VueI18n from 'vue-i18n';
import VueApollo from 'vue-apollo';
import ApolloClient from 'apollo-boost';
import { InMemoryCache } from 'apollo-cache-inmemory';
import JsBarcode from 'jsbarcode';

import 'es6-promise/auto';
import store from './store/index';

import "core-js/stable";
import "regenerator-runtime/runtime";
import "babel-polyfill";

Vue.use(VueI18n);
Vue.use(VueApollo);

const data = require('./lang/messages.json');

try {
    window.AppUtil = require("./project/" + process.env.MIX_STYLE_NAME + ".js").default
} catch (e) {
    window.AppUtil = require("./project/basic.js").default
}

const i18n = new VueI18n({
    locale: 'ja',
    messages: data
});

const client = new ApolloClient({
    uri: process.env.MIX_GRAPHQL_URI + 'graphql',
    request: operation => {
        const token = localStorage.getItem('web-token');
        operation.setContext({
            headers: {
                authorization: token ? `Bearer ${token}` : ''
            }
        });
    }
});

client.defaultOptions.query = {
    fetchPolicy: 'no-cache'
};

const apolloProvider = new VueApollo({
    defaultClient: client,
    cache: new InMemoryCache()
});

new Vue({
    el: '#app',
    i18n,
    router,
    store,
    components: { App },
    template: '<App />',
    JsBarcode,
    apolloProvider,
    methods: {
        handleClick_changeLanguage(lang) {
            this.$i18n.locale = lang;
        }
    }
});

Vue.filter('replace', function(str, a, b) {
    if (!str) return str;
    const re = new RegExp(a, 'g');
    return str.replace(re, b);
});

Vue.filter('date_format_ja', function(str, sep) {
    if (!str) return str;
    str = str.replace(sep, '年').replace(sep, '月') + '日';
    return str;
});

/** ----------------------------------------------
 * カンマ区切り
 * ---------------------------------------------- */
Vue.filter('number_format', function (value) {
    return value.toLocaleString();
});
